/**
 * Created by supun on 10/03/18.
 */
import {
  ACTION_KEY as KEYS,
  ENDPOINTS,
  API_ROUTE,
  REDUX_API_GATEWAY_ACTIONS as ACTIONS,
} from '../../constants/apiGateWayConstant';

const metadata = {};
// schedule
metadata[KEYS.GET_USER] = {
  method: 'GET',
  endPoint: ENDPOINTS.REST_API,
  apiRoute: API_ROUTE.USER_GET,
  failureAction: ACTIONS.GET_USERT_FAILE,
  successAction: ACTIONS.GET_USER_SUCCESS,
};

// public
metadata[KEYS.SEARCH_REPORT] = {
  method: 'GET',
  endPoint: ENDPOINTS.OCR_API,
  apiRoute: API_ROUTE.SEARCH_REPORT,
  failureAction: ACTIONS.GET_REPORT_LINK_FAIL,
  successAction: ACTIONS.GET_REPORT_LINK_SUCCESS,
};

metadata[KEYS.GET_EDITING_REPORT] = {
  method: 'GET',
  endPoint: ENDPOINTS.OCR_API,
  apiRoute: API_ROUTE.GET_EDITING_REPORT,
  failureAction: ACTIONS.GET_EDITING_REPORT_FAIL,
  successAction: ACTIONS.GET_EDITING_REPORT_SUCCESS,
};

metadata[KEYS.UPDATE_REPORT] = {
  method: 'POST',
  endPoint: ENDPOINTS.OCR_API,
  apiRoute: API_ROUTE.UPDATE_REPORT,
  failureAction: ACTIONS.UPDATE_REPORT_FAIL,
  successAction: ACTIONS.UPDATE_REPORT_SUCCESS,
};

metadata[KEYS.GET_REPORTS_DATA] = {
  method: 'GET',
  endPoint: ENDPOINTS.OCR_API,
  apiRoute: API_ROUTE.GET_REPORTS_DATA,
  failureAction: ACTIONS.GET_REPORTS_DATA_FAIL,
  successAction: ACTIONS.GET_REPORTS_DATA_SUCCESS,
};

metadata[KEYS.GET_NEXT_REPORT] = {
  method: 'POST',
  endPoint: ENDPOINTS.OCR_API,
  apiRoute: API_ROUTE.GET_NEXT_REPORT,
  failureAction: ACTIONS.GET_NEXT_REPORT_FAIL,
  successAction: ACTIONS.GET_NEXT_REPORT_SUCCESS,
};

export default metadata;



// WEBPACK FOOTER //
// ./src/saga/ApiGateWay/metadata.js